import { AppAction, ActionType } from './ApplicationContext';
import { ApplicationState } from './ApplicationState';

export const appReducer = (state: ApplicationState, action: AppAction): ApplicationState => {
    const { type } = action;
    switch (type) {
        case ActionType.UPDATE_PERSONAL_DETAILS_ACTION:
            return {
                ...state,
                personalDetails: { ...state.personalDetails, ...action.payload.personalDetails!! }
            };
        case ActionType.UPDATE_CONTACT_DETAILS_ACTION:
            return {
                ...state,
                contactDetails: { ...state.contactDetails, ...action.payload.contactDetails!! }
            };
        case ActionType.UPDATE_ELIGIBILITY_ACTION:
            return {
                ...state,
                eligibility: { ...state.eligibility, ...action.payload.eligibility!! }
            };
        case ActionType.UPDATE_BANK_DETAILS_ACTION:
            return {
                ...state,
                bankDetails: { ...state.bankDetails, ...action.payload.bankDetails!! }
            };
        case ActionType.UPDATE_REVIEW_ACTION:
            return {
                ...state,
                review: { ...state.review, ...action.payload.review!! }
            };
        case ActionType.UPDATE_SUPPORTING_DOCUMENTS_ACTION:
            return {
                ...state,
                supportingDocuments: { ...state.supportingDocuments, ...action.payload.supportingDocuments!! }
            };
        case ActionType.UPDATE_OTHER_DATA:
            // this will completely replace any section defined in the other data
            // in future we may do a deep merge for this.
            return {
                ...state,
                ...action.payload!!
            };
        case ActionType.INITIALISE_TRANSACTION:
            return {
                ...state,
                profileConnectInfo: { ...state.profileConnectInfo, ...action.payload.profileConnectInfo },
                userInfo: { ...state.userInfo, ...action.payload.userInfo },
                transactionDetails: { ...state.transactionDetails, ...action.payload.transactionDetails }
            };
        default:
            return state;
    }
};
